import { topicsData } from '@/mocks/home';

export default function TopicsSection() {
  return (
    <section id="topics" className="py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">热门话题</h2>
          <div className="w-12 h-1 bg-primary-500 mx-auto rounded-full"></div>
          <p className="text-sm text-foreground-500 mt-3">加入讨论，分享你的观影感受</p>
        </div>
        <div className="flex flex-wrap justify-center gap-3 max-w-4xl mx-auto">
          {topicsData.map((topic) => (
            <a
              key={topic.id}
              href="#"
              className={`inline-flex items-center gap-2 px-4 py-2.5 rounded-full text-sm font-medium transition-all duration-200 hover:scale-105 cursor-pointer ${topic.color}`}
            >
              <span>{topic.name}</span>
              <span className="text-xs opacity-70">{topic.count}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}